export function createFooter(): string {
  return `
    <!-- Footer -->
    <footer class="footer">
        <div class="container">
            <div class="footer-content">
                <div class="footer-left">
                    <p class="footer-copyright">© 2025 <em>VibeChk</em>. All rights reserved.</p>
                </div>
                
                <div class="footer-right">
                    <a href="/terms-privacy" class="footer-link">Legal Policy</a>
                    
                    <a href="https://x.com/JustinLiao234" aria-label="Twitter/X" class="footer-social-link" target="_blank">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </footer>

    <!-- Scroll to Top Button -->
    <button class="scroll-to-top" id="scrollToTop" aria-label="Scroll to top">
        <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 14l5-5 5 5z"/>
        </svg>
    </button>
  `;
} 